module.exports = __webpack_public_path__ + "img/violet_080.426119d7.png";